/**
 * LA HIÉRARCHIE DES BOUTONS du module (série UX du témoin, 15/10/2026, 2.2).
 *
 * Ce que le courtier doit vivre : une carte n'a qu'une action principale, et
 * un même geste garde le même poids partout. Trois niveaux, qui suivent le
 * rôle du geste et non l'endroit :
 * - niveau 1, plein, taille normale : l'action principale de la carte (une
 *   seule par carte, celle de l'état) ;
 * - niveau 2, contour, petit : les gestes secondaires ;
 * - niveau 3, lien texte souligné : les gestes de navigation ou de détail.
 *
 * Chaque bouton porte `data-niveau`, que les tests comptent (un seul niveau 1
 * par carte). À poser par `v-bind` sur `BaseButton`.
 */
export const NIVEAU_1 = { "data-niveau": "1" } as const

export const NIVEAU_2 = {
    "data-niveau": "2",
    size: "small",
    outlined: true,
    severity: "secondary",
    class: "border-surface-400! text-primary-800!",
} as const

export const NIVEAU_3 = {
    "data-niveau": "3",
    size: "small",
    text: true,
    severity: "secondary",
    class: "px-0! font-medium! text-primary-800! underline! underline-offset-2!",
} as const

/** Le niveau 3 d'un bouton natif (`<button>`, `<a>`) : les mêmes classes. */
export const CLASSES_NIVEAU_3 =
    "text-sm font-medium text-primary-800 underline underline-offset-2"
